// extracted by mini-css-extract-plugin
export default {"card":"StatisticsCard_card__1RcYL","icon":"StatisticsCard_icon__qreTI"};